import { useState, useEffect, useRef } from 'react';
import { pushEvent } from '../../utils/gtm';
import { buildFAQSchema, buildOrganizationSchema, buildSoftwareApplicationSchema } from '../../utils/schema';
import { useStructuredData } from '../../hooks/useStructuredData';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Speed from './components/Speed';
import NotificationExample from './components/NotificationExample';
import SupportedSites from './components/SupportedSites';
import Pricing from './components/Pricing';
import WhyPaco from './components/WhyPaco';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Contact from './components/Contact';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  useStructuredData(buildFAQSchema(), 'schema-faq');
  useStructuredData(buildOrganizationSchema(), 'schema-org');
  useStructuredData(buildSoftwareApplicationSchema(), 'schema-software');

  const [isScrolled, setIsScrolled] = useState(false);
  const scroll75Fired = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      // ヘッダーの背景切り替え用フラグ
      setIsScrolled(window.scrollY > 50);
      // ページ全体の75%までスクロールしたら1回だけGTMイベントを発火
      if (!scroll75Fired.current) {
        const scrolled = window.scrollY + window.innerHeight;
        const total = document.documentElement.scrollHeight;
        if (scrolled / total >= 0.75) {
          pushEvent('scroll_75');
          scroll75Fired.current = true;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header isScrolled={isScrolled} />
      <Hero />
      <Problem />
      <Solution />
      <Speed />
      <NotificationExample />
      <SupportedSites />
      <Pricing />
      <WhyPaco />
      <FAQ />
      <Contact />
      <FinalCTA />
      <Footer />
    </div>
  );
}
